import React, { useEffect, useState } from "react";
import axios from "axios";
import "./LicencePage.css";
import { getCurrentShopId, getCurrentUser } from "./auth";

const CLOUD_API_URL = process.env.REACT_APP_API_URL || "https://api.deskpos.ie";

function LicencePage() {
  const [licence, setLicence] = useState(null);
  const [error, setError] = useState("");
  const [shopId, setShopId] = useState(null);
/*   const [loading, setLoading] = useState(false); */

  // Software updater states
 /*  const [appVersion, setAppVersion] = useState("");
  const [updateStatus, setUpdateStatus] = useState("Ready");
  const [updateDownloaded, setUpdateDownloaded] = useState(false);
  const [checkingUpdate, setCheckingUpdate] = useState(false); */

  const loadLicence = async (activeShopId = shopId) => {
    try {
      setError("");
      /* setLoading(true); */

      if (!activeShopId) {
        throw new Error("Shop ID not found. Please logout and login again.");
      }

      const res = await axios.get(`${CLOUD_API_URL}/license/check`, {
        params: {
          shop_id: activeShopId,
        },
      });

      console.log("LICENCE FOR SHOP:", activeShopId);
      console.log("LICENCE DATA:", res.data);

      setLicence(res.data);
    } catch (err) {
      console.error("Licence load error:", err.response?.data || err.message);

      setError(
        err.response?.data?.reason ||
          err.response?.data?.error ||
          err.message ||
          "Failed to load licence details",
      );

      setLicence({
        valid: false,
        shop_id: activeShopId || shopId || null,
        reason:
          err.response?.data?.reason ||
          err.response?.data?.error ||
          err.message ||
          "Licence check failed",
      });
    } finally {
     /*  setLoading(false); */
    }
  };

  useEffect(() => {
    const user = getCurrentUser();

    if (!user) {
      setError("No logged-in user found. Please login again.");
      return;
    }

    const currentShopId = getCurrentShopId();

    console.log("LicencePage auth user:", user);
    console.log("LicencePage current shop id:", currentShopId);

    if (!currentShopId) {
      setError(
        "Shop ID not found for this user. Please check the login response.",
      );
      return;
    }

    setShopId(currentShopId);
    loadLicence(currentShopId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 /*  useEffect(() => {
    const ipcRenderer = window.electron?.ipcRenderer;

    const loadAppVersion = async () => {
      try {
        if (!ipcRenderer?.invoke) {
          setAppVersion("Web version");
          return;
        }

        const version = await ipcRenderer.invoke("get-app-version");
        setAppVersion(version);
      } catch (err) {
        console.error("Could not load app version:", err);
        setAppVersion("Unknown");
      }
    };

    const handleUpdateStatus = (_event, data) => {
      console.log("Update status:", data);

      if (!data?.status) return;

      switch (data.status) {
        case "checking":
          setUpdateStatus("Checking for updates...");
          setCheckingUpdate(true);
          break;

        case "available":
          setUpdateStatus(
            `Version ${data.version || ""} is available. Downloading...`,
          );
          setCheckingUpdate(false);
          break;

        case "not-available":
          setUpdateStatus("DeskPOS is up to date.");
          setCheckingUpdate(false);
          break;

        case "download-progress":
          setUpdateStatus(
            `Downloading update: ${Math.round(data.percent || 0)}%`,
          );
          break;

        case "downloaded":
          setUpdateStatus(`Version ${data.version || ""} is ready to install.`);
          setUpdateDownloaded(true);
          setCheckingUpdate(false);
          break;

        case "error":
          setUpdateStatus(data.message || "Update check failed.");
          setCheckingUpdate(false);
          break;

        default:
          break;
      }
    };

    loadAppVersion();

    ipcRenderer?.on?.("update-status", handleUpdateStatus);

    return () => {
      ipcRenderer?.removeAllListeners?.("update-status");
    };
  }, []); */

 /*  const handleCheckForUpdates = async () => {
    try {
      const ipcRenderer = window.electron?.ipcRenderer;

      if (!ipcRenderer?.invoke) {
        setUpdateStatus(
          "Update checking is only available in the installed DeskPOS app.",
        );
        return;
      }

      setCheckingUpdate(true);
      setUpdateDownloaded(false);
      setUpdateStatus("Checking for updates...");

      const result = await ipcRenderer.invoke("check-for-updates");

      if (!result?.success) {
        setUpdateStatus(result?.message || "Could not check for updates.");
        setCheckingUpdate(false);
      }
    } catch (err) {
      console.error("Update check failed:", err);
      setUpdateStatus("Could not check for updates.");
      setCheckingUpdate(false);
    }
  };

  const handleInstallUpdate = async () => {
    try {
      const ipcRenderer = window.electron?.ipcRenderer;

      if (!ipcRenderer?.invoke) {
        setUpdateStatus(
          "Update installation is only available in the installed DeskPOS app.",
        );
        return;
      }

      setUpdateStatus("Restarting DeskPOS to install the update...");

      const result = await ipcRenderer.invoke("install-downloaded-update");

      if (!result?.success) {
        setUpdateStatus(result?.message || "No downloaded update is ready.");
      }
    } catch (err) {
      console.error("Could not install update:", err);
      setUpdateStatus("Could not install the update.");
    }
  };
 */
  const getDaysRemaining = () => {
    if (!licence?.expires_at) return "N/A";

    const today = new Date();
    const expiry = new Date(licence.expires_at);

    today.setHours(0, 0, 0, 0);
    expiry.setHours(0, 0, 0, 0);

    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  const daysRemaining = getDaysRemaining();

  return (
    <div className="licence-page">
      <div className="licence-header">
        <div>
          <h1 style={{ color: "#FFF" }}>Licence</h1>
          <p>
            View this shop&apos;s licence status, plan, expiry date and allowed
            tills.
          </p>
        </div>

        <div
          className={
            licence?.valid ? "licence-status active" : "licence-status inactive"
          }
        >
          {licence?.valid ? "Active" : "Inactive"}
        </div>
      </div>

      {error && <div className="licence-error">{error}</div>}

      <div className="licence-grid">
        <div className="licence-card">
          <span>Shop ID</span>
          <strong>{licence?.shop_id || shopId || "-"}</strong>
        </div>

        <div className="licence-card">
          <span>Plan</span>
          <strong>{licence?.plan_name || "-"}</strong>
        </div>

        <div className="licence-card">
          <span>Status</span>
          <strong>
            {licence?.status || (licence?.valid ? "active" : "inactive")}
          </strong>
        </div>

        <div className="licence-card">
          <span>Max Tills</span>
          <strong>{licence?.max_tills || "-"}</strong>
        </div>

        <div className="licence-card">
          <span>Expiry Date</span>
          <strong>
            {licence?.expires_at
              ? new Date(licence.expires_at).toLocaleDateString()
              : "-"}
          </strong>
        </div>

        <div className="licence-card">
          <span>Days Remaining</span>
          <strong>{daysRemaining}</strong>
        </div>
      </div>

      <div className="licence-details-card">
        <h2>Licence Details</h2>

        <div className="licence-row">
          <span>Licence Valid</span>
          <strong>{licence?.valid ? "Yes" : "No"}</strong>
        </div>

        <div className="licence-row">
          <span>Reason</span>
          <strong>{licence?.reason || "Licence is valid"}</strong>
        </div>

        <div className="licence-row">
          <span>Checked From</span>
          <strong>Cloud Backend</strong>
        </div>
      </div>

      {/* <div className="licence-update-card">
        <div className="licence-update-heading">
          <div>
            <h2>Software Update</h2>
            <p>Check for and install the latest DeskPOS version.</p>
          </div>

          <span className="licence-version-badge">v{appVersion || "..."}</span>
        </div>

        <div className="licence-row">
          <span>Current Version</span>
          <strong>{appVersion || "Loading..."}</strong>
        </div>

        <div className="licence-row">
          <span>Update Status</span>
          <strong>{updateStatus}</strong>
        </div>

        <div className="licence-update-actions">
          <button
            type="button"
            className="licence-update-button"
            onClick={handleCheckForUpdates}
            disabled={checkingUpdate}
          >
            {checkingUpdate ? "Checking..." : "Check for Updates"}
          </button>

          {updateDownloaded && (
            <button
              type="button"
              className="licence-install-button"
              onClick={handleInstallUpdate}
            >
              Restart & Update
            </button>
          )}
        </div>
      </div> */}

      {/* <div className="licence-actions">
        <button onClick={() => loadLicence(shopId)} disabled={loading}>
          {loading ? "Refreshing..." : "Refresh Licence"}
        </button>
      </div> */}
    </div>
  );
}

export default LicencePage;
